module.exports = __webpack_public_path__ + "img/tree.1dcb1e61.svg";